import React, { Component } from "react";
import MyTable from "../Components/Table";

class LeadershipGoOut extends Component {
  render() {
    return <MyTable requestParams="queryAllWorkByPage" classify='校级干部外出报备' />;
  }
}
export default LeadershipGoOut;

